import React, { ClassType, ComponentProps, ReactNode, Component, ComponentClass } from 'react';
import { Page as PdfPage, Text, View, Document as PdfDocument, Image } from '@react-pdf/renderer';
// https://github.com/diegomura/react-pdf/issues/1779
// I renamed `Page` to `PdfPage` on import, and here assigning itto a variable named `Page`
// so that the code here is aligned with `react-pdf` documentation examples,
// same goes with `Document` import.
const Page: ClassType<
    ComponentProps<typeof PdfPage> & { children?: ReactNode },
    Component<ComponentProps<typeof PdfPage> & { children?: ReactNode }>,
    ComponentClass<ComponentProps<typeof PdfPage> & { children?: ReactNode }>
> = PdfPage as any;

const Document: ClassType<
    ComponentProps<typeof PdfDocument> & {
        children: ReactNode;
    },
    Component<
        ComponentProps<typeof PdfDocument> & {
            children: ReactNode;
        }
    >,
    ComponentClass<
        ComponentProps<typeof PdfDocument> & {
            children: ReactNode;
        }
    >
> = PdfDocument as any;

const PdfImage = (props: any) => {

    return <Document>
        <Page size="A4" wrap={true} style={{ padding: '48px', fontSize: '12px' }} >
            <View>
                <Image src={props.src} style={props.style} />
            </View>
        </Page>
    </Document>

}

export default PdfImage;